interface fontsI {
	[key: string]: string
}

export const fonts: fontsI = {
	futura: 'font-futura',
	roboto: 'font-roboto',
	montserrat: 'font-montserrat',
	sans: 'font-sans',
	lato: 'font-lato',
	arial: 'font-arial',
	'sans-serif': 'font-sans-serif',
	default: 'font-lato',
}

export const usePipes = () => ({
	localeStringPipe: (value: unknown) =>
		(value && !isNaN(value as number) && (+value).toLocaleString()) || value,
	currencyPipe: (value: unknown) =>
		((value || value === 0 || value === '0') &&
			!isNaN(value as number) &&
			`${value < 0 ? '-' : ''}$${Math.abs(+value).toLocaleString()}`) ||
		'-',
})
